module.exports = __webpack_public_path__ + "static/media/Daniil_Lebedev.9dfc0aec.jpg";